import React from 'react';
import PropTypes from 'prop-types';

import NumberInputWithStepButtons from '@/common/NumberInputWithStepButtons';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

export default forwardRefWithTranslation('product-editor')(
    class Quantity extends React.Component {
        static propTypes = {
            quantity: PropTypes.number.isRequired,
            onChange: PropTypes.func.isRequired,
            onRemove: PropTypes.func.isRequired,
            is_in_order: PropTypes.bool.isRequired,
            t: PropTypes.func.isRequired,
        };

        setQuantity = value => {
            const { onChange, is_in_order } = this.props;
            if (value === 0 && is_in_order) {
                this.promptToRemove();
                return;
            }
            onChange(value);
        };

        promptToRemove = () => {
            const { t, onRemove } = this.props;
            Mobi2Go.UI.centeredAlert({
                title: t('remove_item_title'),
                body: t('remove_item_body'),
                primary_button: t('remove_item_primary_button'),
                onPrimaryButtonClick: onRemove,
                secondary_button: t('remove_item_secondary_button'),
            });
        };

        render() {
            const { quantity } = this.props;
            return (
                <div className="m2g-product-editor-quantity-control">
                    <NumberInputWithStepButtons
                        value={quantity}
                        setValue={this.setQuantity}
                        classNames={{
                            container: [
                                'm2g-quantity-control',
                                'm2g-product-editor-quantity-control-container',
                            ].join(' '),
                            textInput: [
                                'm2g-quantity-control-text-input',
                                'm2g-product-editor-quantity-control-text-input',
                            ].join(' '),
                            button: [
                                'm2g-quantity-control-button',
                                'm2g-product-editor-quantity-control-button',
                            ].join(' '),
                            buttonContent: [
                                'm2g-quantity-control-button-content',
                                'm2g-product-editor-quantity-control-button-content',
                            ].join(' '),
                        }}
                        onClick={e => e.stopPropagation()}
                        onKeyDown={e => e.stopPropagation()}
                    />
                </div>
            );
        }
    }
);
